import { weakMemoFn } from "@phosphor/utils";
/** Each object reference gets a stable, unique ID */
export const getObjectID = weakMemoFn((_, n) => n);
